import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";
import { createUserSlice } from "./slices/userSlice";
import { createCompanySlice } from "./slices/companySlice";
import { createCampaignSlice } from "./slices/campaignSlice";
import { createFetchCompanyInfoSlice } from "./slices/fetchCompanyInfoSlice";

export const useMainStore = create(
  persist(
    devtools((set, get) => ({
      ...createUserSlice(set, get),
      ...createCompanySlice(set, get),
      ...createCampaignSlice(set, get),
      ...createFetchCompanyInfoSlice(set, get),
    })),
    {
      name: "main-storage",
      getStorage: () => localStorage,
      partialize: (state) => ({
        user: state.user,
        appMode: state.appMode,
        companyProfile: state.companyProfile,
        workflowMode: state.workflowMode,
        sidebarExpanded: state.sidebarExpanded,
        isGeneratingCampaignContent: state.isGeneratingCampaignContent,
      }),
      onRehydrateStorage: () => (state) => {
        // Transient fetch flag — must not survive reloads (was causing stale toasts).
        state?.setIsFetchingCompanyInfo(false);
      },
    }
  )
);
